import { render } from "./StockPage.vue?vue&type=template&id=cf3d4506&scoped=true"
import script from "./StockPage.vue?vue&type=script&lang=js"
export * from "./StockPage.vue?vue&type=script&lang=js"

import "./StockPage.vue?vue&type=style&index=0&id=cf3d4506&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf3d4506"]])

export default __exports__